/* eslint-disable no-console */
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { getAngularAppConfig, RUNTIME_APP_CONFIG } from './app/app.config';

fetch(`./config/config.json`)
    .then((response) => response.json())
    .then((data) => RUNTIME_APP_CONFIG.extend(data))
    .then((data) => {
        bootstrapApplication(AppComponent, getAngularAppConfig(data)).catch((err) => console.error(err));
    });
